{
  "name": "fast-rocket-template-frontend",
  "version": "1.0.0",
  "private": true,
  "scripts": {
    "build": "ng build",
    "build:develop": "ng build --configuration develop",
    "build:local": "ng build --configuration development",
    "build:production": "ng build --configuration production",
    "build:staging": "ng build --configuration staging",
    "compodoc": "npx compodoc -p tsconfig.doc.json",
    "lint": "ng lint --fix",
    "ng": "ng && npm run sentry:sourcemaps",
    "prepare": "husky",
    "prettier": "npx prettier --write .",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org fastrocket-gmbh-lg --project template-frontend ./dist && sentry-cli sourcemaps upload --org fastrocket-gmbh-lg --project template-frontend ./dist",
    "serve:develop": "ng serve --configuration develop",
    "serve:local": "ng serve --configuration development",
    "serve:production": "ng serve --configuration production",
    "serve:staging": "ng serve --configuration staging",
    "start": "ng serve -o",
    "test": "ng test"
  },
  "dependencies": {
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/router": "^19.2.14",
    "@casl/ability": "^6.7.1",
    "@casl/angular": "^9.0.3",
    "@commitlint/config-conventional": "^19.2.2",
    "@fullcalendar/angular": "^6.0.3",
    "@fullcalendar/core": "^6.0.3",
    "@fullcalendar/daygrid": "^6.0.3",
    "@fullcalendar/interaction": "^6.0.3",
    "@fullcalendar/timegrid": "^6.0.3",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@primeng/themes": "^19.1.3",
    "@sentry/angular": "^8.37.1",
    "@sentry/cli": "^2.38.2",
    "@types/file-saver-es": "^2.0.2",
    "angular-gridster2": "^19.0.0",
    "chart.js": "^4.4.3",
    "commitlint": "^19.3.0",
    "echarts": "^5.5.1",
    "eml-parser": "^2.0.3",
    "file-saver": "^2.0.5",
    "file-saver-es": "^2.0.5",
    "hammerjs": "^2.0.8",
    "jspdf": "^2.5.1",
    "jspdf-autotable": "^3.7.0",
    "jszip": "^3.10.1",
    "jwt-decode": "^3.1.2",
    "moment": "^2.30.1",
    "ngx-cookie-service": "^19.1.2",
    "ngx-doc-viewer": "^15.0.1",
    "ngx-echarts": "^17.2.0",
    "ngx-extended-pdf-viewer": "^24.0.0-alpha.2",
    "ngx-image-cropper": "^8.0.0",
    "pdf-lib": "^1.17.1",
    "pdfjs-dist": "^4.3.136",
    "primeclt": "^0.1.5",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^19.1.3",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "sanitize-html": "^2.13.0",
    "tailwindcss-primeui": "^0.5.1",
    "tippy.js": "^6.3.7",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zod": "^3.23.8"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular-eslint/builder": "20.1.1",
    "@angular-eslint/eslint-plugin": "20.1.1",
    "@angular-eslint/eslint-plugin-template": "20.1.1",
    "@angular-eslint/schematics": "20.1.1",
    "@angular-eslint/template-parser": "20.1.1",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@types/jasmine": "~4.3.0",
    "@types/sanitize-html": "^2.11.0",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "autoprefixer": "^10.4.20",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^9.0.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^5.0.0",
    "husky": "^9.0.11",
    "jasmine-core": "~4.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^15.2.7",
    "postcss": "^8.4.49",
    "prettier": "^3.3.2",
    "prettier-eslint": "^15.0.1",
    "tailwindcss": "^3.4.17",
    "typescript": "5.5"
  }
}
